import { FC } from 'react'
import styled from 'styled-components'
import { swaapPurple2 } from '../Themes'

interface Props {
  onSwitch: () => void
}

export function ArrowDown({ onSwitch }: Props) {
  return (
    <div className="arrow down" onClick={onSwitch} style={{cursor:"pointer"}}>
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={swaapPurple2} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      	<line x1="12" y1="5" x2="12" y2="19"></line>
      	<polyline points="19 12 12 19 5 12"></polyline>
      </svg>
    </div>
  )
}